import axios from 'axios';
import API from '../Api';

export function editWhyChooseUs(params) {
    return axios.post(API.EDIT_WHY_CHOOSE_US, params)
}

export function getWhyChooseUs(params) {
    return axios.get(API.GET_WHY_CHOOSE_US, params)
}